import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { GroupBy } from './pipes/group-by.pipe';

@NgModule({
  imports: [],
  declarations: [ 
    GroupBy
  ],
  exports: [
    GroupBy
  ]
})
export class SharedModule {}